import { gql } from "@apollo/client";

export const GET_CASE_NOTES = gql`
  query GetCaseNotes($caseId: String!) {
    getNotesByCaseId(caseId: $caseId) {
      id
      createdAt
      updatedAt
      title
      body
      orgId
      caseId
    }
  }
`;
